import _ from 'lodash'
import { utils } from 'frontend-js-shared'

export const normalizeSignatureItem = item => {
  if (item?.type !== 'signature') return item
  if (item?.signature) return item

  const media = item?.responseImages?.[0] ?? null
  const signerId = item?.signer?.id ?? item?.signer?._id ?? item?.signer ?? null
  const signerName = buildAccountFullName(item?.signer)

  if (!media) {
    return {
      ...item,
      signature: null,
    }
  }

  return {
    ...item,
    signature: {
      media,
      mediaId: media?.id ?? media?._id ?? media ?? null,
      mediaUrl: media?.url ?? null,
      signerId: signerId ?? null,
      signerName: signerName || null,
      resolvedSignerName: signerName || null,
    },
  }
}

export const normalizeChecklistItems = (items = []) => {
  return items.map(normalizeSignatureItem)
}

export const buildAccountFullName = account => {
  return [
    account?.displayname ?? account?.displayName ?? '',
    account?.familyname ?? account?.familyName ?? '',
  ]
    .filter(Boolean)
    .join(' ')
    .trim()
}

export const collectSignatureSignerIds = (items = []) => {
  return _.uniq(
    items
      .filter(item => item?.type === 'signature')
      .filter(item => !item?.signature?.resolvedSignerName)
      .map(item => utils.getEntityId(item?.signature?.signerId))
      .filter(Boolean)
  )
}

export const attachResolvedSignatureSignerNames = (
  items = [],
  accountsById = new Map()
) => {
  return items.map(item => {
    if (item?.type !== 'signature' || !item?.signature) return item

    const signerId = utils.getEntityId(item.signature.signerId)
    const resolvedSigner = signerId ? accountsById.get(signerId) : null
    const resolvedSignerName = buildAccountFullName(resolvedSigner)
    const signerIsAccountObject =
      item.signer &&
      typeof item.signer === 'object' &&
      !Array.isArray(item.signer)

    return {
      ...item,
      signer: signerIsAccountObject ? item.signer : resolvedSigner || item.signer,
      signature: {
        ...item.signature,
        resolvedSignerName:
          resolvedSignerName || item.signature?.resolvedSignerName || null,
      },
    }
  })
}

export const withUnresolvedSignatureSignerNames = (items = []) => {
  return items.map(item => {
    if (item?.type !== 'signature' || !item?.signature) return item

    return {
      ...item,
      signature: {
        ...item.signature,
        resolvedSignerName: item.signature?.resolvedSignerName || null,
      },
    }
  })
}
